module.exports = __webpack_public_path__ + "static/media/BlueWheelDrivediscpackage.c9370058.webp";